import React from "react";
import "./Home.css";
import myPhoto from "../../assets/mypic1.jpg";
import snake from "../../assets/snake.svg";
import WhatIDo from "./whatIDo/WhatIDo";
import Project from "../project/Project";
import { BlurFade } from "../magicUi/blur-fade";
import HyperText from "../magicUi/HyperText";
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Ai from "../../assets/ai.png";
function Home({ openChat }) {
   const location = useLocation();
  const projectRef = useRef(null);

  useEffect(() => {
    if (location.state?.scrollTo === 'projects') {
      setTimeout(() => {
        projectRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100); // Slight delay to ensure DOM is ready
    }
  }, [location]);

  return (

    <div className="home-container ">
    <div className="home-content bg-gradient-to-b from-blue-100 to-white h-[80vh]">
      <div className="left-section">
        <div>
  
          <BlurFade delay={0.15} inView>
          <h1 className="text-2xl sm:text-4xl font-bold bg-gradient-to-r   from-[#3A506B] to-[#5BC0BE] text-transparent bg-clip-text">
            Building secure, scalable, and 
          </h1>
          <h1 className="text-2xl sm:text-4xl font-bold">
            stunning applications with Java, React, AWS and AI</h1>
          
          </BlurFade>
   
           <BlurFade delay={0.65} inView>
           <button
            className="chat-button flex items-center  gap-2 bg-gradient-to-r from-[#246463] via-[#5BC0BE] to-[#9eeeed] width=50%"
            onClick={openChat}
          >
            Don't trust? Talk to my 
            <HyperText text=" assistant! " />
            <img src={Ai} className="w-8 h-8" alt="AI"/>
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 48 48">
              <radialGradient id="oDvWy9qKGfkbPZViUk7TCa_eoxMN35Z6JKg_gr1" cx="-670.437" cy="617.13" r=".041" gradientTransform="matrix(128.602 652.9562 653.274 -128.6646 -316906.281 517189.719)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1ba1e3"></stop><stop offset="0" stop-color="#1ba1e3"></stop><stop offset=".3" stop-color="#5489d6"></stop><stop offset=".545" stop-color="#9b72cb"></stop><stop offset=".825" stop-color="#d96570"></stop><stop offset="1" stop-color="#f49c46"></stop></radialGradient><path fill="url(#oDvWy9qKGfkbPZViUk7TCa_eoxMN35Z6JKg_gr1)" d="M22.882,31.557l-1.757,4.024c-0.675,1.547-2.816,1.547-3.491,0l-1.757-4.024	c-1.564-3.581-4.378-6.432-7.888-7.99l-4.836-2.147c-1.538-0.682-1.538-2.919,0-3.602l4.685-2.08	c3.601-1.598,6.465-4.554,8.002-8.258l1.78-4.288c0.66-1.591,2.859-1.591,3.52,0l1.78,4.288c1.537,3.703,4.402,6.659,8.002,8.258	l4.685,2.08c1.538,0.682,1.538,2.919,0,3.602l-4.836,2.147C27.26,25.126,24.446,27.976,22.882,31.557z"></path><radialGradient id="oDvWy9qKGfkbPZViUk7TCb_eoxMN35Z6JKg_gr2" cx="-670.437" cy="617.13" r=".041" gradientTransform="matrix(128.602 652.9562 653.274 -128.6646 -316906.281 517189.719)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#1ba1e3"></stop><stop offset="0" stop-color="#1ba1e3"></stop><stop offset=".3" stop-color="#5489d6"></stop><stop offset=".545" stop-color="#9b72cb"></stop><stop offset=".825" stop-color="#d96570"></stop><stop offset="1" stop-color="#f49c46"></stop></radialGradient><path fill="url(#oDvWy9qKGfkbPZViUk7TCb_eoxMN35Z6JKg_gr2)" d="M39.21,44.246l-0.494,1.132	c-0.362,0.829-1.51,0.829-1.871,0l-0.494-1.132c-0.881-2.019-2.467-3.627-4.447-4.506l-1.522-0.676	c-0.823-0.366-0.823-1.562,0-1.928l1.437-0.639c2.03-0.902,3.645-2.569,4.511-4.657l0.507-1.224c0.354-0.853,1.533-0.853,1.886,0	l0.507,1.224c0.866,2.088,2.481,3.755,4.511,4.657l1.437,0.639c0.823,0.366,0.823,1.562,0,1.928l-1.522,0.676	C41.677,40.619,40.091,42.227,39.21,44.246z"></path>
            </svg> */}
          </button>
       
          </BlurFade>
        </div>
        <BlurFade delay={1.15} inView>
        <p style={{ color: '#3A506B' }}>
      
          Hello, I'm Bibhu! a passionate full-stack developer with experience in React, Java,
          Spring Boot, AWS, and more. I love building web applications and solving
          problems through code.
        </p>
        </BlurFade>
        <img src={snake} alt="My GitHub Snake Animation" />

      </div>
      <div className="right-section">
        <img src={myPhoto} alt="Bibhu" className="profile-photo" />
      </div>
      
    </div>
    <WhatIDo/>
  
    <section ref={projectRef}>
    <Project/>
    </section>
 
    </div>
  );
}

export default Home;
